function setSaleRecord() {
  const recordKey = "all-bags-24";
  const recordValue = "true";
  const now = new Date();
  
  if (window.location.pathname === "/collections/handbags-promotion/products/convertible-backpack-purse" || window.location.pathname === "/collections/cognac-collection-promo") {
    localStorage.setItem(recordKey, recordValue);
  }


  let targetTime = new Date();
  targetTime.setUTCHours(23 - 4, 59, 0, 0); // Учитываем GMT-4
  
  if (now > targetTime) {

    targetTime.setDate(targetTime.getDate() + 1);
  }
  
  const timeToExpiry = targetTime - now;
  
  setTimeout(() => {
    localStorage.removeItem(recordKey);
  }, timeToExpiry);
}

function showDiscountWrapperIfSale() {
  const recordKey = "all-bags-24";
  const discountWrapper = document.querySelector(
    ".main-product__personal-discount-wrapper"
  );

  if (localStorage.getItem(recordKey) === "true" && discountWrapper) {
    discountWrapper.style.display = "flex"; // Делаем элемент видимым
  } else {}
}


window.onload = function () {
  setSaleRecord();
  showDiscountWrapperIfSale();
};


function dailyCheck() {
  const now = new Date();
  

  let targetTime = new Date();
  targetTime.setUTCHours(23 - 4, 59, 0, 0); // Учитываем GMT-4
  
  if (now > targetTime) {

    targetTime.setDate(targetTime.getDate() + 1);
  }
  
  const timeToExpiry = targetTime - now;

  setTimeout(() => {
    localStorage.removeItem("all-bags-24");
    dailyCheck(); 
  }, timeToExpiry);
}

window.onload = function () {
  setSaleRecord();
  showDiscountWrapperIfSale();
  dailyCheck(); 
};